import React from 'react';
import HomePresenter from './HomePresenter';

const HomeContainer: React.FC = () => {
  return (
    <React.Fragment>
      <HomePresenter />
    </React.Fragment>
  );
};

export default HomeContainer;
